module.exports = __webpack_public_path__ + "images/898ab390bfc2995c96be9fe5b07536bd.jpg";